import {svgIconWrapper} from '../svg-icon-wrapper';

import ChatbotRegularReport from './chatbot-regular-report-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ChatbotRegularReport {...props} />;
}
SvgComponent.iconName = 'chatbotRegularReport';

export const ChatbotRegularReportIcon = svgIconWrapper(SvgComponent);
